import DatePicker from "react-datepicker"
import {forwardRef} from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../../../css/element/DateSelector.css";
import {ko} from 'date-fns/esm/locale'

const CustomInput = forwardRef(({value, onClick}, ref) => (
    <div className="date-selector-single" ref={ref}>
        <p className="date-selector-text">
            {value}
        </p>
        <div className="calendar-icon-container" onClick={onClick}></div>
    </div>
))
let TeacherDateSelector = (props) => {
    return (<DatePicker dateFormat="yyyy-MM-dd" selected={props.date}
                        locale={ko}
                        onChange={date => {
                            props.setDate(date)
                        }}
                        customInput={<CustomInput/>}
    />)
}
export default TeacherDateSelector;